export const isDevPc = process.env.DEVPC;
export const isCi = () => !!process.env.CI_CLUSTER;
export const isInteractiveDevPc = () => isDevPc && !isCi();
export const envHome = process.env.HOME;
export const isVeryVerbose = process.env.VERYVERBOSE;
export const isOpenCode = process.env.OPENCODE === '1';
export const isOcWeb = process.env.OCWEB === '1';
